import { Injectable, Signal, Type, inject } from '@angular/core';
import { Router } from '@angular/router';
import { EnumerationTypeDto } from '@digiwall/core/proxy';
import {
  PlanningDataSource,
  PlanningItemDto,
  ProductionStepPlanningService,
} from '@digiwall/goliath-documents/proxy';
import { GoliathDocumentsEnumerationTypeStore } from '../../../enumeration-types/enumeration-type.store';
import { BasePlanningAdapter } from '../base-planning.adapter';
import { PlanningDataSourceAdapter } from '../planning-adapter';
import { ProductionStepBoardFilterComponent } from './production-step-board-filter.component';
import { ProductionStepPlanningCardComponent } from './production-step-planning-card.component';
import {
  PRODUCTION_STEP_CARD_FIELDS,
  ProductionStepPlanningItemFieldsDto,
} from './production-step-planning-item-fields';
import { PlanningCardFieldDescriptor } from '../planning-card-field';

/** Planning adapter for ProductionFolder steps (WorkOrderStepLine). */
@Injectable({ providedIn: 'root' })
export class ProductionStepPlanningAdapter
  extends BasePlanningAdapter
  implements PlanningDataSourceAdapter
{
  private readonly router = inject(Router);
  private readonly store = inject(GoliathDocumentsEnumerationTypeStore);

  readonly dataSource = PlanningDataSource.ProductionStep;
  readonly cardComponent: Type<unknown> = ProductionStepPlanningCardComponent;
  readonly boardFilterComponent: Type<unknown> = ProductionStepBoardFilterComponent;
  readonly statusEnumeration: Signal<EnumerationTypeDto[]> = this.store.workOrderStatus;
  readonly cardFields: PlanningCardFieldDescriptor[] = PRODUCTION_STEP_CARD_FIELDS;

  constructor() {
    super(inject(ProductionStepPlanningService));
  }

  searchText(dto: PlanningItemDto): string {
    const fields = (dto.displayFields ?? {}) as ProductionStepPlanningItemFieldsDto;
    return [
      fields.displayNumber,
      fields.customer,
      fields.stepName,
      fields.equipment,
      fields.worker,
      fields.manufacturer,
      fields.responsible,
    ]
      .filter(Boolean)
      .join(' ');
  }

  openItem(dto: PlanningItemDto): void {
    // The item id is the step-line id, so deep-link to the owning folder carried in displayFields.
    const fields = (dto.displayFields ?? {}) as ProductionStepPlanningItemFieldsDto;
    if (!fields.productionFolderId) {
      return;
    }
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/', 'production', 'folder-docs', fields.productionFolderId]),
    );
    window.open(url, '_blank');
  }
}
